var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"ma-0 pa-0 full-size",staticStyle:{"background-color":"#fff","height":"100%"},attrs:{"fluid":""}},[_c('v-card',{attrs:{"height":_vm.windowHeight}},[_c('v-card-text',{staticStyle:{"height":"100%"}},[_c('Blog')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }